export const ENTRY_ID = 'EYHiNYE44OeGXUqxPeRK4'
export const QUERY_TYPE = 'article'
export const LOADING_TEXT = 'Loading...'
